import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { fetchCommonInvitation, joinCommonInvitation } from '../../services/compositionApi';
import './InvitationLuxe.css';

// Lien COMMUN du collectif : /invitation/:token (refonte du collectif, phase 2, decision du fondateur 2026-10-24).
// La personne donne son prenom ; le serveur cree SON invitation et lui rend son lien individuel, ou elle ajoute ses photos
// exactement comme une personne invitee par e-mail. Le navigateur retient ce lien : revenir sur le lien commun n'en cree pas
// un second (sauf autre appareil ou navigation privee — on ne peut pas mieux sans compte).
const cleMemoire = (token) => `bookipix.collectif.${token}`;

export default function CollectiveJoinLuxe() {
  const { t, i18n } = useTranslation('collective');
  const { token } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [erreur, setErreur] = useState('');
  const [prenom, setPrenom] = useState('');
  const [enCours, setEnCours] = useState(false);
  const champ = useRef(null);

  useEffect(() => {
    let deja = null;
    try { deja = window.localStorage.getItem(cleMemoire(token)); } catch (_e) { deja = null; }
    if (deja) { navigate(`/collectif/${deja}`, { replace: true }); return; }
    fetchCommonInvitation(token)
      .then((r) => setInfo(r))
      .catch((err) => setErreur(err.message || t('join.invalid')));
  }, [token, navigate, t]);

  const rejoindre = async (event) => {
    event.preventDefault();
    if (prenom.trim().length < 2) { setErreur(t('participate.nameRequired')); champ.current?.focus(); return; }
    setEnCours(true);
    setErreur('');
    try {
      const { inviteToken } = await joinCommonInvitation(token, prenom.trim());
      try { window.localStorage.setItem(cleMemoire(token), inviteToken); } catch (_e) { /* sans memoire : on continue quand meme */ }
      navigate(`/collectif/${inviteToken}`, { replace: true });
    } catch (err) {
      setErreur(err.message || t('join.failed'));
      setEnCours(false);
    }
  };

  if (!info) {
    return (
      <div className="invitation-container">
        <div className="invitation-card" style={{ textAlign: 'center' }}>
          {erreur ? <><h1>{t('join.invalidTitle')}</h1><p className="body-text" style={{ color: 'var(--text-light)' }}>{erreur}</p></> : <p role="status">{t('join.loading')}</p>}
        </div>
      </div>
    );
  }

  const titre = info.eventTitle || info.bookTitle;
  const date = info.deadline ? new Date(`${info.deadline}T12:00:00`).toLocaleDateString(i18n.language, { day: 'numeric', month: 'long' }) : '';
  return (
    <div className="invitation-container">
      <div className="invitation-card">
        <h1>{info.organizerName ? t('join.titleFrom', { name: info.organizerName }) : t('join.title')}</h1>
        {titre && <p className="body-text" style={{ fontWeight: 700 }}>{titre}</p>}
        {info.message && <p className="body-text" style={{ color: 'var(--text-light)', whiteSpace: 'pre-wrap' }}>« {info.message} »</p>}
        {date && <p className="body-text" style={{ fontWeight: 600 }}>{info.isClosed ? t('join.closedOn', { date }) : t('join.deadline', { date })}</p>}
        {info.isFinished ? (
          <div className="wizard-error">{t('guest.finishedBody', { name: info.organizerName || t('guest.someone') })}</div>
        ) : info.isClosed ? (
          <div className="wizard-error">{t('participate.collectionClosed')}</div>
        ) : (
          <form onSubmit={rejoindre} noValidate>
            {erreur && <div className="wizard-error" role="alert">{erreur}</div>}
            <div className="form-group">
              <label htmlFor="join-name">{t('participate.nameLabel')}</label>
              <input id="join-name" ref={champ} className="input-luxe" value={prenom} onChange={(e) => setPrenom(e.target.value)} maxLength={80} autoComplete="given-name" placeholder={t('participate.namePlaceholder')} />
              <small className="collective-field-hint">{t('participate.nameHint')}</small>
            </div>
            <button type="submit" className="btn btn-primary" disabled={enCours}>{enCours ? t('join.joining') : t('join.continue')}</button>
            <p className="body-text" style={{ color: 'var(--text-light)', fontSize: 13, marginTop: 12 }}>{t('join.noAccount')}</p>
          </form>
        )}
      </div>
    </div>
  );
}
